import Vue from 'vue'
import VueRouter from 'vue-router'
import Form from '@/components/Form'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'CalcForm',
    component: Form
  }
]

const router = new VueRouter({
  routes
})

export default router
